import React, { FC, useContext } from 'react';
import { Route, useRouteMatch } from 'react-router-dom'
import NavWrapper from '../components/wrappers/NavWrapper'
import InternalNavigation from '../pages/customermanagement/internalnavigation'
import { userContext } from '../utils/userContext'

export interface RouteCustomerProps {
    page: number
}

export class RouteCustomerProps implements RouteCustomerProps {
    constructor(page: number = 0) {
        this.page = page
    }
}

const ParkingSolvisionRouter: FC = () => {
    let match = useRouteMatch()
    const { hasModule } = useContext(userContext)

    return (
        <NavWrapper pageName="Kundeadministration">
            {!hasModule(match.url) ?
                <Route component={() => <div>Du har ikke adgang til Parking Solvision opsætning</div>}/>
            :
                <InternalNavigation />
            }
        </NavWrapper>
    )
}

export default ParkingSolvisionRouter
